
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/projekt",
      function () {
        return require("private-next-pages/info/projekt.tsx");
      }
    ]);
  